<!-- header -->
<app-header extraClass="text-gray nav-down" standardProduct=true displayNavigation=true></app-header>

<!--CONTACT CARD-->
<section class="contact-us-wrp mt-110 mb-5">
  <div class="container">
    <div class="contact-us-wrp-inner">
      <h4>Contact Us</h4>
<div class="uk-flex uk-flex-column">
      <div class="contact-card-top uk-flex uk-flex-center">
        <div class="contact-card uk-flex">
          <div class="icons">
           <!-- <img src="assets/images/icons/call-2.png" alt="">-->
           <i class="fa fa-phone fa-3x text-white"></i>

          </div>
          <div class="info">
            <h3>Tollfree number</h3>
            <a href="tel:18002567666">1800 266 7666</a>
          </div>
        </div>
        <!--contact-card-->
        <div class="contact-card uk-flex">
          <div class="icons">
            <!--<img src="assets/images/icons/mail-2.png" alt="">-->
            <i class="fa fa-envelope fa-3x text-white"></i>
          </div>
          <div class="info">
            <h3>Email Id</h3>
            <a href="mailto:support@things2.do">support@things2.do</a>
          </div>
        </div>
        <!--contact-card-->
        <div class="contact-card uk-flex">
          <div class="icons">
            <!--<img src="assets/images/icons/call-3.png" alt="">-->
            <i class="fa fa-clock-o fa-3x text-white"></i>
          </div>
          <div class="info">
            <h3>Customer Care</h3>
            <p>10 am - 8 pm</p>
          </div>
        </div>
        <!--contact-card-->
      </div>
      <!--contact-card-top-->

      <div class="contact-card-field-wrp mt-5">
        <h4 *ngIf="!enquirySuccessful">Required Fields*</h4>

        <div class="border-form-input">
          <!-- Contact Form -->
          <form class="uk-flex uk-flex-wrap uk-flex-between" #enquiryNgForm="ngForm" [formGroup]="enquiryForm"
                method="post" (ngSubmit)="submitEnquiry()"
                *ngIf="!enquirySuccessful">
            <div class="form-group">
              <div class="uk-inline">
                                    <span class="uk-form-icon">
                                      <!--<img src="assets/images/icons/people.png" alt="">-->
                                      <i class="fa fa-user"></i>
                                    </span>
                <input class="uk-input" placeholder="Full Name" type="text" name="full_name" required="required"
                       minlength="4" [formControlName]="'name'">
              </div>

              <div *ngIf="f.name.touched && f.name.invalid" class="error">
                <div *ngIf="f.name.errors.required">Full Name is required.</div>
                <div *ngIf="f.name.errors.minlength">Please enter at least 4 characters.</div>
              </div>

            </div>
            <div class="form-group">
              <div class="uk-inline">
                                    <span class="uk-form-icon">
                                     <!-- <img src="assets/images/icons/mail.png" alt="">-->
                                     <i class="fa fa-envelope"></i>
                                    </span>
                <input class="uk-input" placeholder="Email Id" type="email" name="email" required="required"
                       minlength="4" [formControlName]="'email'">
              </div>
              <div *ngIf="f.email.touched && f.email.invalid" class="error">
                <div *ngIf="f.email.errors.required">Email is required.</div>
                <div *ngIf="f.email.errors.invalid">Invalid Email.</div>
              </div>

            </div>
            <div class="form-group">
              <div class="uk-inline">
                                    <span class="uk-form-icon">
                                      <!--<img src="assets/images/icons/call.png" alt="">
                                      -->
                                      <i class="fa fa-phone"></i>
                                    </span>
                <input class="uk-input" placeholder="Enter Mobile No." type="tel" name="mobile_number"
                       required="required" minlength="10" [formControlName]="'mobile_number'">
              </div>
              <div *ngIf="f.mobile_number.touched && f.mobile_number.invalid" class="error">
                <div *ngIf="f.mobile_number.errors.required">Mobile Number is required.</div>
                <div *ngIf="f.mobile_number.errors.pattern">Please, Enter 10 digit Mobile Number.</div>
              </div>
            </div>
            <div class="form-group mt-2 w-100">
              <textarea class="uk-textarea" placeholder="{{queryType?'Enter your Suggestion':'Any specific request?'}}"
                        name="query_data" required
                        [formControlName]="'query_data'">
              </textarea>
              <div *ngIf="f.query_data.touched && f.query_data.invalid" class="error">
                <div *ngIf="f.query_data.errors.required">{{queryType?'Suggestion':'Query'}} is required.</div>
                <div *ngIf="f.query_data.errors.minlength">Please enter at least 10 characters.</div>
              </div>
            </div>
            <div class="form-group mt-4 w-100 btn-box">
              <button type="submit" class="btn-yellow cursor-pointer">
                <i class="fa fa-spinner fa-spin" *ngIf="enquiryResponseAwaited"></i>
                Send
              </button>
            </div>

            <small *ngIf="enquiryResponseReceived">{{enquiryErrorMessage}}</small>
            <span class="error" *ngIf="errorMessage">{{errorMessage}}</span>
          </form>

          <ng-container *ngIf="enquirySuccessful">
            <div class="thankyou-box">
              <img src="assets/images/icons/right-green.png" alt="">
              <h6>Thank you {{enquiryPayLoad.full_name}}</h6>
              <p>for your response. We will reach <br> out to you shortly!</p>
            </div>
          </ng-container>

        </div>
      </div>
      <!--contact-card-field-wrp-->
</div>

    </div>
  </div>
</section>
<app-footer></app-footer>
